import { defineMessages } from "react-intl";

import image00 from "@app/assets/guides/jasperSavedFilters/00.png";
import image01 from "@app/assets/guides/jasperSavedFilters/01.png";
import image02 from "@app/assets/guides/jasperSavedFilters/02.png";
import image03 from "@app/assets/guides/jasperSavedFilters/03.png";
import image04 from "@app/assets/guides/jasperSavedFilters/04.png";
import image05 from "@app/assets/guides/jasperSavedFilters/05.png";
import image06 from "@app/assets/guides/jasperSavedFilters/06.png";
import image07 from "@app/assets/guides/jasperSavedFilters/07.png";
import image08 from "@app/assets/guides/jasperSavedFilters/08.png";
import image09 from "@app/assets/guides/jasperSavedFilters/09.png";
import image10 from "@app/assets/guides/jasperSavedFilters/10.png";
import image11 from "@app/assets/guides/jasperSavedFilters/11.png";
import image12 from "@app/assets/guides/jasperSavedFilters/12.png";
import WizardDescriptor from "@app/component/flows/types/WizardDescriptor";

const messages = defineMessages({
  step00: {
    id: "guides.jasperSavedFiltersMobile.wizard.step0",
    defaultMessage: "Map",
  },
  step00Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step0.description",
    defaultMessage: "Navigate to the Map tab.",
  },
  step01: {
    id: "guides.jasperSavedFiltersMobile.wizard.step1",
    defaultMessage: "Filters",
  },
  step01Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step1.description",
    defaultMessage: "Access the Filters via the three lines in the Search Bar.",
  },
  step02: {
    id: "guides.jasperSavedFiltersMobile.wizard.step2",
    defaultMessage: "Select the blue plus button in the bottom right corner to add a new Filter",
  },
  step02Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step2.description",
    defaultMessage:
      "If you currently have any Filters applied - clear these before creating your Saved Filter.",
  },
  step03: {
    id: "guides.jasperSavedFiltersMobile.wizard.step3",
    defaultMessage: "Filter type",
  },
  step03Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step3.description",
    defaultMessage: "Select Company Filter",
  },
  step04: {
    id: "guides.jasperSavedFiltersMobile.wizard.step4",
    defaultMessage: "Select Field",
  },
  step04Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step4.description",
    defaultMessage:
      "Scroll through the list of fields to T Group or use the search bar at the top of the list to find this field.",
  },
  step05: {
    id: "guides.jasperSavedFiltersMobile.wizard.step5",
    defaultMessage: "Choose comparison",
  },
  step05Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step5.description",
    defaultMessage: "Select the “is exactly” parameter and press Continue.",
  },
  step06: {
    id: "guides.jasperSavedFiltersMobile.wizard.step6",
    defaultMessage: "Enter the value",
  },
  step06Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step6.description",
    defaultMessage:
      "You are now brought back to the initial Filter screen - within the Filter you have applied, enter the numeric value of the T Group you would like to create a Filter for (EX: 100) and select “Apply” in the bottom right corner.",
  },
  step07: {
    id: "guides.jasperSavedFiltersMobile.wizard.step7",
    defaultMessage: "On the Map",
  },
  step07Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step7.description",
    defaultMessage:
      "You will now see records Filtered for your selected T Group. Click the Filter icon (three lines) once more to layer another rule.",
  },
  step08: {
    id: "guides.jasperSavedFiltersMobile.wizard.step8",
    defaultMessage: "One more filter",
  },
  step08Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step8.description",
    defaultMessage:
      "Select the blue plus button and then Company Filter and select the OSR Frequency Field.",
  },
  step09: {
    id: "guides.jasperSavedFiltersMobile.wizard.step9",
    defaultMessage: "Filter details",
  },
  step09Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step9.description",
    defaultMessage:
      "Select the “is any of” parameter and press Continue. Choose the OSR Frequency values you would like, then “Done”. This Filter will now be layered on top of the existing T Group Filter.",
  },
  step10: {
    id: "guides.jasperSavedFiltersMobile.wizard.step10",
    defaultMessage: "Create Saved Filter",
  },
  step10Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step10.description",
    defaultMessage: "Click the blue Save button in the bottom left corner of the screen.",
  },
  step11: {
    id: "guides.jasperSavedFiltersMobile.wizard.step11",
    defaultMessage: "Saved Filter details",
  },
  step11Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step11.description",
    defaultMessage:
      "Name this Filter for the T Group and Frequency you selected (Ex. T Group 100 Freq 12/6). Turn on the “Show as favorite quick filter” toggle and select Save.",
  },
  step12: {
    id: "guides.jasperSavedFiltersMobile.wizard.step12",
    defaultMessage: "Congratulations!",
  },
  step12Description: {
    id: "guides.jasperSavedFiltersMobile.wizard.step12.description",
    defaultMessage:
      "You have successfully created a Saved Filter! This Filter will now live at the top of your Map and will be accessible to turn on and off this particular data set as needed. You will want to repeat this process for all your T Groups and any other Filters you would like to have accessible at the top of your mobile Map.",
  },
  title: {
    id: "guides.jasperSavedFiltersMobile.wizard",
    defaultMessage: "Creating Saved Filters on Mobile / iPad Guide",
  },
});

export const jasperSavedFiltersForMobile: WizardDescriptor = {
  id: "mmc-jasper-saved-filters-mobile",
  steps: [
    {
      id: "open-map",
      description: messages.step00Description,
      image: image00,
      title: messages.step00,
    },
    {
      id: "map-filters",
      description: messages.step01Description,
      image: image01,
      title: messages.step01,
    },
    {
      id: "add-saved-filter",
      description: messages.step02Description,
      image: image02,
      title: messages.step02,
    },
    {
      id: "select-company-filter",
      description: messages.step03Description,
      image: image03,
      title: messages.step03,
    },
    {
      id: "select-field",
      description: messages.step04Description,
      image: image04,
      title: messages.step04,
    },
    {
      id: "select-operator",
      description: messages.step05Description,
      image: image05,
      title: messages.step05,
    },
    {
      id: "enter-value",
      description: messages.step06Description,
      image: image06,
      title: messages.step06,
    },
    {
      id: "add-more-filters",
      description: messages.step07Description,
      image: image07,
      title: messages.step07,
    },
    {
      id: "select-entity-field",
      description: messages.step08Description,
      image: image08,
      title: messages.step08,
    },
    {
      id: "select-another-operator-and-value",
      description: messages.step09Description,
      image: image09,
      title: messages.step09,
    },
    {
      id: "save-filter",
      description: messages.step10Description,
      image: image10,
      title: messages.step10,
    },
    {
      id: "saved-filter-form",
      description: messages.step11Description,
      image: image11,
      title: messages.step11,
    },
    {
      id: "finish",
      description: messages.step12Description,
      image: image12,
      title: messages.step12,
    },
  ],
  title: messages.title,
};
